"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTimeout", {
    enumerable: true,
    get: function() {
        return useTimeout;
    }
});
const _useBrowserTimer = require("./useBrowserTimer");
function useTimeout() {
    // TODO: figure it out a way to not call global.setTimeout and instead infer window from some context
    return (0, _useBrowserTimer.useBrowserTimer)(setTimeout, clearTimeout);
}
